<!-- La escena de la puesta en marcha: el comercio en el centro y, alrededor, lo que se le va creando.
     Sin pasos no se dibuja nada. El texto `aria-live` dice lo mismo que el titular de la escena. -->
<div #caja class="escena" *ngIf="hayPasos">
  <canvas #lienzo class="escena-lienzo" role="img" [attr.aria-label]="rotulo"></canvas>
  <p class="sr-only" aria-live="polite">{{ anuncio }}</p>

  <!-- Lo que no aplica o está en curso, con lo que dijo el núcleo: el lienzo lo recorta, aquí se lee entero. -->
  <div class="mt-3 space-y-1" *ngIf="avisos.length">
    <p class="text-sm" *ngFor="let a of avisos">
      <span class="font-medium" [ngClass]="a.alerta ? 'kb-td-alerta' : 'text-foreground'">{{ a.nombre }}</span>
      <span class="kb-badge ml-2" [ngClass]="a.alerta ? 'kb-badge-alerta' : 'kb-badge-neutro'"><i class="fas fa-clock" aria-hidden="true" *ngIf="a.alerta"></i> {{ a.alerta ? 'Esperando · generándose' : a.estado }}</span>
      <span class="text-muted-foreground pem-envolver"> {{ a.texto }}</span>
    </p>
  </div>

  <!-- AL FINAL, y sólo si algo falló: la lista de lo que falló, con su porqué y su «Reintentar». -->
  <div class="pem-fallos" *ngIf="fallos.length">
    <div class="pem-fallos-cab">
      <div class="min-w-0">
        <p class="text-sm font-medium text-foreground">{{ fallos.length === 1 ? 'Un ítem no se pudo crear' : fallos.length + ' ítems no se pudieron crear' }}</p>
        <p class="kb-hint !mt-0.5">{{ resumenFallos }}</p>
      </div>
      <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" *ngIf="puedeReintentar && fallos.length > 1"
              [disabled]="ocupado" (click)="pedirReintentoTodo()">Reintentar todo</button>
    </div>
    <div class="pem-fallo" *ngFor="let f of fallos">
      <span class="pem-fallo-punto" aria-hidden="true"></span>
      <div class="pem-fallo-txt">
        <p class="text-sm font-medium text-foreground">{{ f.nombre }} · <span class="font-normal text-muted-foreground">{{ f.grupo }}</span></p>
        <p class="text-sm kb-texto-peligro pem-envolver">{{ f.porque }}</p>
        <p class="kb-hint !mt-0.5 pem-envolver" *ngIf="f.esperan.length">Esperan a que se resuelva: {{ f.esperan.join(', ') }}.</p>
      </div>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm shrink-0" *ngIf="puedeReintentar && f.completar"
              [disabled]="ocupado" (click)="pedirCompletar(f.clave)">Completar el domicilio</button>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm shrink-0" *ngIf="puedeReintentar && !f.completar"
              [disabled]="ocupado" (click)="pedirReintentoPaso(f.clave)">Reintentar</button>
    </div>
  </div>

  <!-- Operativa: el kit de bienvenida, si el paso trae su enlace. -->
  <div class="pem-kit" *ngIf="enlaceKit">
    <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground" [href]="enlaceKit" target="_blank" rel="noopener">
      <i class="fas fa-file-pdf" aria-hidden="true"></i> Descargar el kit
    </a>
  </div>

  <!-- Los colores del lienzo salen de aquí: las clases del tema y las variables `--pem-*` del :host. -->
  <div #sondas class="sondas" aria-hidden="true">
    <span class="s-frente text-foreground"></span>
    <span class="s-tenue text-muted-foreground"></span>
    <span class="s-borde border border-border"></span>
    <span class="s-exito"></span>
    <span class="s-ambar"></span>
    <span class="s-apagado"></span>
    <span class="s-brillo"></span>
    <span class="s-peligro kb-texto-peligro"></span>
    <span class="s-alerta kb-td-alerta"></span>
    <span class="s-fondo bg-card"></span>
    <span class="s-mono font-mono"></span>
  </div>
</div>
